import type { SwimInputData, BikeInputData, RunInputData } from '@opentri/shared/zones';
import apiClient from './apiClient';

export interface PhysioValueProps {
  physio_id?: number;
  user_id: number;
  css_swim?: number;
  pma?: number;
  vma?: number;
  cs?: number;
  cp?: number;
  swim_input_data?: SwimInputData | null;
  bike_input_data?: BikeInputData | null;
  run_input_data?: RunInputData | null;
  updated_at?: Date;
}

export type { SwimInputData, BikeInputData, RunInputData };

export const getPhysioValues = async (userId: string): Promise<PhysioValueProps> => {
  const response = await apiClient.get(`physioValues/${userId}`);
  return response.data as PhysioValueProps;
};

export const updatePhysioValuesForUser = async (
  userId: string,
  payload: PhysioValueProps | Omit<PhysioValueProps, 'user_id'>
): Promise<PhysioValueProps> => {
  const response = await apiClient.put(`admin/physioValues/${userId}`, payload);
  return response.data as PhysioValueProps;
};
